import React from "react";
import "./Zones.css"
import "./Commons.css"
import * as RestApi from "./RestApi"
import {checkMikaResponseSuccess} from "./RestApi"
import {InfoListButton} from "./Containers"
import deleteBtnImage from "./Images/delete_icon.png";
import createBtnImage from "./Images/add_icon.png";
import {CancelButton, CategorySelector, ConfirmButton} from "./Controllers";

export class ZonesView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isEditing: false, zones: null, editedZone: null};
        this.refreshAvailableZones = this.refreshAvailableZones.bind(this);
        this.setEditorEnabled = this.setEditorEnabled.bind(this);
    }

    setEditorEnabled(enabled, zone) {
        this.setState({isEditing: enabled, editedZone: (enabled ? zone : null)});
        if (!enabled)
            this.refreshAvailableZones();
    }

    async componentDidMount() {
        await this.refreshAvailableZones();
    }

    async refreshAvailableZones() {
        const resp = await RestApi.getUpdatedZones();
        if (await checkMikaResponseSuccess(resp))
            this.setState({zones: resp.zones});
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.refreshZones)
            await this.refreshAvailableZones();
    }

    render() {
        let zones_list;
        if (this.state.zones)
            zones_list = this.state.zones.map(zone => <ZonesListItem key={zone.id}
                                                                     zone={zone}
                                                                     onClick={this.setEditorEnabled.bind(null, true, zone)}
                                                                     refreshDelegate={this.refreshAvailableZones}
                                                                     info={`${zone.name} - ${zone.category}`}/>)
        if (this.state.isEditing)
            return (
                <div className="ZonesContainer">
                    <ZoneEditorPanel zone={this.state.editedZone} setEditorEnabled={this.setEditorEnabled}/>
                </div>
            );
        else return (
            <div className="ZonesContainer">
                <div className="ViewListHeader">
                    <div>Info Zona</div>
                    <div>Elimina<br/>zona</div>
                </div>
                {zones_list}
                <CreateNewZoneButton refreshDelegate={this.refreshAvailableZones}/>
            </div>
        );
    }
}

export function ZonesListItem(props) {
    let zone = props.zone;
    return (
        <div className="ViewListItemWideFlex">
            <InfoListButton onClick={props.onClick} info={props.info}/>
            <DeleteZoneButton refreshDelegate={props.refreshDelegate} zId={zone.id}/>
        </div>
    );
}

export function CreateNewZoneButton(props) {
    async function createZone() {
        const zoneName = window.prompt("Nome Zona:");
        if (zoneName != null) {
            let zone = {};
            zone.id = ""; // A unique ID will be given by the server, but the field needs to be there in the first place.
            zone.name = zoneName;
            zone.category = "Free";
            zone.qr_codes = [];
            const resp = await RestApi.addZone(zone);
            if (await checkMikaResponseSuccess(resp))
                props.refreshDelegate();
        }
    }

    return (
        <div className="newListItemContainer">
            <div>Aggiungi Zona</div>
            <button className="CreateNewListItemButton" onClick={createZone}>
                <img alt="Create Zone" src={createBtnImage} className="imgFitParent"/>
            </button>
        </div>
    )
}

export function DeleteZoneButton(props) {
    async function deleteZone() {
        const confirmation = window.confirm("Confermi eliminazione?");
        if (confirmation) {
            const resp = await RestApi.removeZone(props.zId);
            await checkMikaResponseSuccess(resp);
            await props.refreshDelegate();
        }
    }

    return (
        <button className="DeleteListItemButton" onClick={deleteZone}>
            <img alt="Delete Zone" className="imgFitParent" src={deleteBtnImage}/>
        </button>);
}

export class ZoneEditorPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            zone: props.zone,
            zoneName: props.zone.name,
            zoneCategory: props.zone.category,
            zoneQrs: props.zone.qr_codes
        };
        this.zoneUpdateCancel = this.zoneUpdateCancel.bind(this);
        this.zoneUpdateConfirm = this.zoneUpdateConfirm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleQrChange = this.handleQrChange.bind(this);
        this.addNewQr = this.addNewQr.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        let value;
        switch (target.name) {
            case "zoneCategory":
            case "zoneName":
            default: {
                value = target.value;
                this.setState({[target.name]: value});
            }
        }
    }

    handleQrChange(index, id, category) {
        let qrs = this.state.zoneQrs;
        qrs[index].id = id;
        qrs[index].category = category;
        this.setState({zoneQrs: qrs});
    }

    addNewQr() {
        let qrs = this.state.zoneQrs;
        qrs.push({
            category: this.state.zoneCategory,
            id: Math.trunc(Math.random() * 10000).toString()
        });
        this.setState({zoneQrs: qrs});
    }

    removeQr(index) {
        let qrs = this.state.zoneQrs;
        qrs.splice(index, 1);
        this.setState({zoneQrs: qrs});
    }

    async zoneUpdateConfirm() {
        let zone = {
            id: this.state.zone.id,
            category: this.state.zoneCategory,
            name: this.state.zoneName,
            qr_codes: this.state.zoneQrs
        };
        const resp = await RestApi.updateZone(zone);
        if (!await checkMikaResponseSuccess(resp))
            alert("Errore di comunicazione con il server.");
        this.props.setEditorEnabled(false, null);
    }

    zoneUpdateCancel() {
        this.props.setEditorEnabled(false, null);
    }

    render() {
        const qrCodes = this.state.zoneQrs;
        const qr_items = qrCodes.map((qr, i) => <QrCodeItem key={i} index={i} qr={qr}
                                                            removeQr={this.removeQr.bind(this, i)}
                                                            onQrChange={this.handleQrChange.bind(this, i)}/>);
        return (
            <div className="FullSizeFlexRow">
                <div className="ZoneEditorLeftSide">
                    <label className="smallHeader">
                        Nome Zona:
                        <input className="textInput" type="text" value={this.state.zoneName} name="zoneName"
                               onChange={this.handleInputChange}/>
                    </label>
                    <label className="smallHeader">
                        Categoria:
                        <CategorySelector name="zoneCategory" onChange={this.handleInputChange}
                                          value={this.state.zoneCategory}/>
                    </label>
                    <button className="button purple" onClick={this.addNewQr}>Aggiungi QR</button>
                    <br/>
                    <div className="confirmCancelBox">
                        <ConfirmButton onClick={this.zoneUpdateConfirm}/>
                        <CancelButton onClick={this.zoneUpdateCancel}/>
                    </div>
                </div>
                <div className="ZoneEditorRightSide">
                    {qr_items}
                </div>
            </div>
        );
    }
}

function QrCodeItem(props) {
    function handleIdChange(event) {
        const target = event.target;
        props.onQrChange(target.value, props.qr.category);
    }

    function handleCategoryChange(event) {
        const target = event.target;
        props.onQrChange(props.qr.id, target.value);
    }

    return (
        <div className="ZoneQrBox">
            <div className="ZoneQrBoxLeftSide">
                <label className="fullWidth smallHeader">
                    ID:<input className="zoneQrIdText textInput" type="text" value={props.qr.id}
                              onChange={handleIdChange}/>
                </label>
                <label className="fullWidth smallHeader">
                    Categoria:<CategorySelector name="QrCategory"
                                                value={props.qr.category} onChange={handleCategoryChange}/>
                </label>
            </div>
            <div className="ZoneQrBoxRightSide">
                <button className="DeleteListItemButton" onClick={props.removeQr}>
                    <img alt="Delete QR"
                         className="imgFitParent"
                         src={deleteBtnImage}/>
                </button>
            </div>
        </div>
    );
}